import { TOptionValue } from '../Types';

export const getProfessionName = (
  professions: TOptionValue<string>[],
  profession?: string,
): string => {
  const result = professions.find((it) => it.value === profession);

  if (!profession || !result) {
    return 'Dental Hygienist';
  }

  return result.label;
};
